import { render, staticRenderFns } from "./WidgetCheckbox.vue?vue&type=template&id=131ea57c"
import script from "./WidgetCheckbox.vue?vue&type=script&lang=js"
export * from "./WidgetCheckbox.vue?vue&type=script&lang=js"
import style0 from "./WidgetCheckbox.vue?vue&type=style&index=0&id=131ea57c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports